@if (saveButtonSizeDuringLoading || !loading) {
  @if (svgIconPath) {
    <svg-icon
      class="button-icon"
      preserveAspectRatio="none"
      [class.invisible]="isLoadingWithSavedButtonSize"
      [src]="svgIconPath"
      [stretch]="true"
    ></svg-icon>
  }

  @if (!isOnlyIcon) {
    <span
      class="button-content"
      [ngClass]="{ 'inline-block truncate': truncate }"
      [class.invisible]="isLoadingWithSavedButtonSize"
    >
      <ng-content></ng-content>
    </span>
  }

  @if (isLoadingWithSavedButtonSize) {
    <app-circle-loader class="absolute-loader" [appearance]="loaderAppearance"></app-circle-loader>
  }
} @else {
  <app-circle-loader class="static-loader" [appearance]="loaderAppearance"></app-circle-loader>
}
